import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { AUTH_DATA_FACADE } from '../../services/facades';
import { StageConfigService } from '../../services/stage-config/stage-config.service';
import { MYTC_API_VERSION } from 'src/app/shared/constants/http-context/mytc-api-version';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private readonly authDataFacade = inject(AUTH_DATA_FACADE);
  private readonly stageConfigService = inject(StageConfigService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authDataFacade.getUser().pipe(
      switchMap((myTcUser) => {
        const apiVersion = request.context.get(MYTC_API_VERSION) ?? this.stageConfigService.config.mytcApiVersion;

        request = request.clone({
          setHeaders: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            'api-version': apiVersion.toString(),
          },
        });

        if (myTcUser?.access_token && request.url.indexOf(this.stageConfigService.config.paymentsApiUrl) === -1) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${myTcUser.access_token}`,
            },
          });
        }

        return next.handle(request);
      }),
    );
  }
}
